export const BaseZIndex = 9000;
//# sourceMappingURL=zIndex.js.map